module.exports = __webpack_public_path__ + "img/ogatemini.08a824be.png";